import Vue from 'vue';
import VueI18n from 'vue-i18n';

import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import ElementLocale from 'element-ui/lib/locale'

import zhCN from "./lang/zhCh.js";
import en from "./lang/en.js";
import es from "./lang/es.js";
import cs from "./lang/cs.js";
import pt from "./lang/pt.js";

Vue.use(VueI18n)

// 准备翻译的语言环境信息
const messages = {
    // zh-CN:中文 en:英文 es:西班牙语 cs:捷克语 pt:葡萄牙语
    'zh-CN': { ...zhCN, ...zhLocale },
    'en': {
        ...en,
        ...enLocale // 或者用 Object.assign({ message: 'XX' }, enLocale)
    },
    'es': {
        ...es,
    },
    'cs': {
        ...cs,
    },
    'pt': {
        ...pt,
    }
}

// 通过选项创建 VueI18n 实例
const i18n = new VueI18n({
    locale: 'zh-CN', // 设置地区
    messages, // 设置地区信息
})


ElementLocale.i18n((key, value) => i18n.t(key, value));

export default i18n;





// WEBPACK FOOTER //
// ./src/i18n/i18n.js